<div class="footer">
  <div class="container">
    <div class="flex-row flex-col-md fill footer-md">
      <div class="logo-container">
        <a href="https://www.smartinsurtech.de/" target="_blank">
          <img
            class="footer-logo"
            src="assets/img/logos/smartinsurtech_neg.svg"
            alt="Logo"
          />
        </a>
        <a
          href="https://www.hypoport.de/unternehmensprofil/hypoport-insurtech/"
          target="_blank"
        >
          <img
            class="footer-logo"
            src="assets/img/HYPOPORT_INSURTECH_Banner_small_100Px.webp"
            alt="Wir sind Teil von HYPOPORT INSURTECH"
        /></a>
      </div>
      <div class="address-container">
        <p>Heidestraße 8</p>
        <p>10557 Berlin</p>
        <p>Tel. +49 30 700160400</p>
        <p>Mail: info&#64;tarifair.de</p>
        <p>Web: https://www.smartinsurtech.de</p>
      </div>
      <div class="flex-grow link-container">
        <div>
          <button
            mat-button
            onclick="window.open('assets/doc/smit-allgemeine_geschaeftsbedingungen.pdf', '_blank', 'fullscreen=yes'); return false;"
          >
            Geschäftsbedingungen</button
          ><button
            mat-button
            onclick="window.open('assets/doc/Impressum.pdf', '_blank', 'fullscreen=yes'); return false;"
          >
            Impressum</button
          ><button
            mat-button
            onclick="window.open('assets/doc/privacy.pdf', '_blank', 'fullscreen=yes'); return false;"
          >
            Datenschutz
          </button>
        </div>
        <p class="copyright">
          Smart InsurTech AG ©2014-{{ currentYear }} -- Made with
          <i class="fa fa-regular fa-heart" aria-hidden="true"></i> in
          Heidelberg
        </p>
        <a
          title="linkedin"
          href="https://www.linkedin.com/company/smart-insurtech"
          target="_blank"
          rel="noopener"
        >
          <img src="assets/img/linkedin.svg" alt="linkedin link"
        /></a>
        <a
          title="facebook"
          href="https://www.facebook.com/SmartInsurTechAG"
          target="_blank"
          rel="noopener"
        >
          <img src="assets/img/facebook.svg" alt="facebook link"
        /></a>
        <a
          title="youtube"
          href="https://www.youtube.com/c/SmartInsurTechAG"
          target="_blank"
          rel="noopener"
        >
          <img src="assets/img/youtube.svg" alt="youtube link"
        /></a>
        <a
          title="twitter"
          href="https://twitter.com/SmartInsurTech"
          target="_blank"
          rel="noopener"
        >
          <img src="assets/img/twitter.svg" alt="twitter link"
        /></a>
        <a
          title="xing"
          href="https://www.xing.com/companies/smartinsurtechag"
          target="_blank"
          rel="noopener"
        >
          <img src="assets/img/xing.svg" alt="xing link"
        /></a>
      </div>
    </div>
  </div>
</div>
